<template>
    <div class="topic">
        <div class="topic_title">{{topic.title}}</div>
        <p v-if="(!topic.disabled&&!topic.selectIndex&&showRight)||(!topic.disabled&&!topic.selectIndex)" style="color:red;line-height:30px;font-size:16px"> × 此题未答,此题答案为: {{topic.right==1?'A':(topic.right==2?'B':(topic.right==3?'C':'D'))}} {{topic.options?topic.options[topic.right-1]:''}}</p>
        <div class="options">
            <div class="option" v-for="(item, index) in topic.options" :key="index" @click="selectOption(index)">
                <span class="icon" :class="[{success:index+1 == topic.successIndex||(topic.right == index+1&&!topic.disabled)},{fail: topic.selectFail && topic.selectIndex == index+1}]"><span class="success-icon">{{topic.selectFail && topic.selectIndex == index+1 ? '×' : '√'}}</span></span><span style="color: #333">{{index==0?'A':(index==1?'B':(index==2?'C':'D'))}} {{item}}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'my-options',
    props:['topic','showRight'],
    // props:{
    //     topic:  Array,
    //     listen: Function
    // },
    data(){
        return {
            showAnswer: false
        }
    },
    created(){
        this.$root.center.$on('showAnswer',data=>{
            this.showAnswer = true;
        })
        // this.Right = this.showRight?this.showRight:true;
        this.$root.center.$on('noanswer',data=> {
            this.topic.disabled = data;
            this.$root.center.$emit('changeTopic',this.topic)
            this.$root.center.$emit('answered',0);
            // console.log('未答的',this.topic)
        })
    },
    methods:{
        selectOption(index){
            // console.log(index)
            if(this.topic.disabled){
                this.topic.successIndex = this.topic.right;
                this.topic.selectIndex = index+1;
                // console.log(this.topic.selectIndex)
                // 选择正确
                // console.log(index+1 == this.topic.successIndex)
                if(index+1 == this.topic.successIndex){
                    this.topic.selectSuccess = true;
                    this.topic.selectFail = false;
                    this.topic.disabled = false;
                    // console.log('dadui选择后的',this.topic)
                    // this.$root.center.$emit('changeTopic',this.topic)
                    this.$root.center.$emit('answered',1);
                }
                // 选择错误 
                else if(index+1 != this.topic.successIndex){
                    this.topic.selectSuccess = true;
                    this.topic.selectFail = true;
                    this.topic.disabled = false;
                    // console.log('dacuo选择后的',this.topic)
                    // this.$root.center.$emit('changeTopic',this.topic)
                    this.$root.center.$emit('answered',2);
                }
            }
        }
    },
    beforeDestroy(){
        // console.log('销毁');
        this.$root.center.$off('answered');
        this.$root.center.$off('noanswer');
        this.$root.center.$off('changeTopic');
    }
}
</script>

<style>
    .topic .topic_title{
        font-family:PingFangSC-Medium;
        font-size:19px;
        color:#333333;
        /* font-weight: bold; */
        margin-top: 10px;
        margin-bottom: 20px;
    }
    .topic .option{
        font-family:PingFangSC-Regular;
        font-size:15px;
        line-height: 30px;
        color:#333333;
        padding: 10px 0;
        border-top: 1px solid rgba(225, 230, 234,.5);
    }
    /* .option::before{
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        background-color: rgba(225, 230, 234,.5);
    } */
    .option span{
        line-height: 12px;
        color: #fff;
    }
    .option .icon{
        display: inline-block;
        border:2px solid #e1e6ea;
        width:19px;
        height:19px;
        border-radius:100%;
        margin-right: 10px;
        text-align: center;
    }
    .option .success-icon{
        font-size: 10px;
    }
    .option .success{
        border-color: #5576ab;
        background-color: #5576ab;
    }
    .option .fail{
        background-color: #ff5e5e;
        border-color: #ff5e5e;
    }
</style>



// WEBPACK FOOTER //
// src/components/options/options.vue